import styles from "./styles.module.scss";
import classNames from "classnames";
import { WidgetClass } from "@services/widget.service";
import { FormatDataProps, PerformanceColor, TableItem } from "./utils.types";

const widgetClass = new WidgetClass();

const getPerformanceColor = (performance: string): PerformanceColor => {
  const colorMap: Record<string, PerformanceColor> = {
    Good: "green",
    Mid: "yellow",
    Poor: "darkRed",
    "No Sales": "red",
  };

  return colorMap[performance] || "yellow";
};

const getPerformanceValue = (performance: string): number => {
  const valueMap: Record<string, number> = {
    Good: 1,
    Mid: 2,
    Poor: 3,
    "No Sales": 4,
  };

  return valueMap[performance] || 5;
};

const renderColoredCell = (value: any, color: PerformanceColor) => (
  <div className={classNames(styles.cell, color)}>{value}</div>
);

export const formatData = ({
  data,
  openTooltip,
  openedTooltip,
  keyTooltip,
  setKeyTooltip,
  keyword,
  setKeywords,
  withKeywords,
}: FormatDataProps): TableItem[] => {
  if (!data?.length) return [];

  const formattedData = data.map((item) => {
    const newItem = { ...item };
    const color = newItem.performance
      ? getPerformanceColor(newItem.performance)
      : undefined;

    if (newItem.performance) {
      newItem.performanceSortValue = getPerformanceValue(newItem.performance);
    }

    Object.entries(newItem).forEach(([key, value]) => {
      if (typeof value === "number") {
        newItem[key] = widgetClass.formatValue(key, value) || value;
      }

      if (value === null) {
        newItem[key] = "-";
      }

      if (key === "ad_sales" || key === "ad_spend") {
        newItem[key] = renderColoredCell(newItem[key], color);
      }
    });

    if (newItem.children) {
      newItem.children = formatData({
        data: newItem.children,
        openTooltip,
        openedTooltip,
        keyTooltip,
        setKeyTooltip,
        keyword,
        setKeywords,
        withKeywords,
        parentAsin: newItem.campaign,
      });
    }

    return newItem;
  });

  formattedData.sort((a, b) => {
    if (a.performanceSortValue && b.performanceSortValue) {
      return a.performanceSortValue - b.performanceSortValue;
    }
    return 0;
  });

  return formattedData;
};
